const ExitIcon = () =>{
    
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.2607 8.0625L21.1982 12L17.2607 15.9375" stroke="#7B7E7C" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.6953 12H21.1953" stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
                d="M12.1953 20.25H5.44531C5.2464 20.25 5.05563 20.171 4.91498 20.0303C4.77433 19.8897 4.69531 19.6989 4.69531 19.5V4.5C4.69531 4.30109 4.77433 4.11032 4.91498 3.96967C5.05563 3.82902 5.2464 3.75 5.44531 3.75H12.1953"
                stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default ExitIcon